import { render, staticRenderFns } from "./CreateHospitalUserForm.vue?vue&type=template&id=6f2c4c78&"
import script from "./CreateHospitalUserForm.vue?vue&type=script&lang=js&"
export * from "./CreateHospitalUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports